<template>
    <v-app>
      <Header />
      <SideMenu v-if="!smAndDown" />
      <MobileNav v-if="smAndDown" />
      <slot />
      <v-snackbar :model-value="snackbar.show" :color="snackbar.color" :timeout="4000" @update:model-value="hideSnackbar">
        {{ snackbar.message }}
      </v-snackbar>
    </v-app>

  </template>

  <script>
  import { useDisplay } from 'vuetify'
  import { mapState, mapMutations } from 'vuex'
  import Header from '../components/Header.vue'
  import SideMenu from '../components/SideMenu.vue'
  import MobileNav from '../components/MobileNav.vue'

  export default {
    name: 'App',
    components: {
      Header,
      SideMenu,
      MobileNav
    },
    setup() {
      const { smAndDown } = useDisplay()
      return { smAndDown }
    },
    computed: {
      ...mapState(['snackbar'])
    },
    methods: {
      ...mapMutations(['hideSnackbar'])
    }
  }
  </script>

  <style>

  </style>
